<app-navbar></app-navbar>

<section class="min-h-[50dvh] bg-black text-black">
    <div class="w-full">
        <div class="min-h-[50dvh] bg-no-repeat bg-cover bg-center relative" style="background-image: url(/assets/img/excellence/tuv-sud/659fafaea90b19bf86c92a97__UHX1905.webp);">
            <div class="absolute inset-0 bg-gradient-to-b from-black/60 to-black/90"></div>
            <div class="text-white relative z-10">
                <div class="pt-40 max-w-3xl mx-auto text-center p-8">
                    <div class="justify-center items-center mx-auto">
                        <img src="/assets/img/excellence/tuv-sud/65771a6da01233ffd04d54ad_TUV_Logo.webp" alt="tuvsud-image" srcset="" class="w-52 mx-auto mb-4" />
                        <p class="text-4xl font-bold">TÜD SÜV</p>
                        <p class="mt-5 text-xl">{{texts.subtitle}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="bg-white text-black py-10">
        <div class="max-w-4xl mx-4 md:mx-auto">
            <div>
                <h2 class="text-3xl font-bold mb-4">{{texts.section.title}}</h2>
                <p class="mb-6 text-justify">
                    {{texts.section.text_history}}
                </p>
                
            </div>
            <div>
                <h2 class="text-3xl font-bold mb-4">TÜV SÜD</h2>
                <p class="mb-6 text-justify">
                    {{texts.section.text_general[0]}}
                </p>
                <p class="mb-6 text-justify">
                    {{texts.section.text_general[1]}}
                </p>
                <p class="mb-6 text-justify">
                    {{texts.section.text_general[2]}}
                </p>
                
            </div>
            
            <div class="flex items-center justify-center mx-auto mt-10">
                <iframe class="w-4/5 h-96" src="https://www.youtube.com/embed/KltWQvLabIk?si=I0a8ZP1M6pjavY89" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>

            </div>

            <div>
                <h3 class="text-2xl font-bold mt-10 mb-4">{{texts.section.resultados_title}}</h3>
                <p class="mb-6">
                    {{texts.section.result_text}}
                </p>
                <!-- Component: Small primary basic button -->
                <a href="https://www.prinxtire.eu/tires/product/quattura-4s#tuv-result" target="_blank" class="inline-flex items-center justify-center h-8 gap-2 px-4 text-xs font-medium tracking-wide text-white transition duration-300 rounded-full focus-visible:outline-none whitespace-nowrap bg-black hover:bg-black/80 focus:bg-black/80 disabled:cursor-not-allowed disabled:border-black/60 disabled:bg-black/60 disabled:shadow-none">
                    <span>{{texts.section.see_btn}}</span>
                </a>
                <!-- End Small primary basic button -->
            </div>
        </div>
        
    </div>

</section>

<app-footer></app-footer>